import { gql } from '@apollo/client'

export const COMPANY_CREATE_MUTATION = gql`
  mutation COMPANY_CREATE_MUTATION($company: CompanyCreateInput!) {
    companyCreate(company: $company) {
      ok
    }
  }
`

export const COMPANY_UPDATE_MUTATION = gql`
  mutation COMPANY_UPDATE_MUTATION($id: ID!, $company: CompanyUpdateInput!) {
    companyUpdate(id: $id, company: $company) {
      ok
    }
  }
`

export const COMPANY_UPDATE_RISK_RESPONSE_MUTATION = gql`
  mutation COMPANY_UPDATE_RISK_RESPONSE_MUTATION($id: ID!, $input: CompanyUpdateRiskResponseTypesInput!) {
    companyUpdateRiskResponseTypes(id: $id, input: $input) {
      ok
    }
  }
`
